import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button, Typography, FormControlLabel, Switch, IconButton, Grid} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { ModalBox } from '../../../styles/ModalStyles';

const EditarCompromisoModal = ({ open, onClose, onSubmit, compromiso }) => {
  const [id, setId] = useState('');
  const [idNormativa, setIdNormativa] = useState('');
  const [nombre, setNombre] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [habilitado, setHabilitado] = useState(false);
  
  useEffect(() => {
    if (compromiso) {
      setId(compromiso.id);
      setIdNormativa(compromiso.idNormativa);
      setNombre(compromiso.nombre);
      setDescripcion(compromiso.descripcion);
      setHabilitado(compromiso.habilitado);
    }
  }, [compromiso]);


  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ id, idNormativa, nombre, descripcion, habilitado});
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalBox sx={{ 
        width: '80%', 
        maxWidth: '1000px', 
        minHeight: '600px',
        padding: '24px'
      }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography variant='h6' sx={{ mb: 3 }}>Editar Compromiso</Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={4}>
          <Grid item xs={12}>
            <Box sx={{ 
              border: '1px solid rgba(0,0,0,0.23)', 
              borderRadius: 1, 
              p: 3,
              height: '100%'
            }}>
              <Typography variant="subtitle1" gutterBottom>
                Descripción del Compromiso
              </Typography>
              <TextField
                fullWidth
                label="Descripción"
                value={descripcion}
                onChange={(e) => setDescripcion(e.target.value)}
                margin="normal"
                required
                multiline
                rows={15}
                variant="outlined"
                sx={{ 
                  '& .MuiOutlinedInput-root': {
                    height: 'auto',
                    minHeight: '200px'
                  }
                }}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={habilitado}
                    onChange={(e) => setHabilitado(e.target.checked)}
                    color="primary"
                  />
                }
                label={habilitado ? "Habilitado" : "Deshabilitado"}
              />
            </Box>
          </Grid>
          
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
              <Button type="submit" variant="contained" color="primary" sx={{ mr: 1 }}>
                Guardar
              </Button>
              <Button onClick={onClose} variant="contained" color="error">
                Cancelar
              </Button>
            </Box>
          </Grid>
          </Grid>
        </form>
      </ModalBox>
    </Modal>
  );
};

export default EditarCompromisoModal;